import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'importer-app-loading-screen',
  templateUrl: './loading-screen.component.html',
  styleUrls: ['./loading-screen.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class LoadingScreenComponent {
  @Input() local?: boolean;
  @Input() contrast?: boolean;

  constructor() {}
}
